// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogVariantStockThresholdForm from "./CatalogVariantStockThresholdForm.res.js";

function CatalogVariantStockThresholdFormInputs(props) {
  return JsxRuntime.jsxs(Stack.make, {
    children: [
      JsxRuntime.jsx(CatalogVariantStockThresholdForm.InputNumber.make, {
        field: "MaxStockThreshold",
        label: I18n.t("Maximum stock"),
        hideRequired: true,
        minValue: 0,
        precision: 0
      }),
      JsxRuntime.jsx(CatalogVariantStockThresholdForm.InputNumber.make, {
        field: "MinStockThreshold",
        label: I18n.t("Minimum stock"),
        hideRequired: true,
        minValue: 0,
        precision: 0
      }),
      JsxRuntime.jsx(CatalogVariantStockThresholdForm.InputNumber.make, {
        field: "StockOrderTriggerThreshold",
        label: I18n.t("Stock triggering the order"),
        hideRequired: true,
        minValue: 0,
        precision: 0
      })
    ],
    space: "medium"
  });
}

let make = React.memo(CatalogVariantStockThresholdFormInputs);

export {
  make,
}
/* make Not a pure module */
